import * as THREE from "three";

const ThreeBSP = require("three-js-csg")(THREE);
///创建墙面对象
///boxx盒子的x长度
///boxy盒子的y长度
///boxz盒子的z长度
///angle 旋转角度
///material 墙面纹理
///x 所在坐标x
///y所在坐标y
///z所在坐标z

export function createWallObject(boxx, boxy, boxz, angle, material, x, y, z,name,visible=true) {

    var geometry = new THREE.BoxGeometry(boxx, boxy, boxz);
    //var material3 = new THREE.MeshLambertMaterial(_this.matArrayB); //材质对象Material2
    var mesh = new THREE.Mesh(geometry, material);
    mesh.translateX(x);
    mesh.translateZ(z);
    mesh.translateY(y);
    mesh.rotation.y += angle * Math.PI; //-逆时针旋转,+顺时针
    mesh.name=name;
    mesh.visible=visible;
    return mesh;
}
//创建墙纹理
export function createWallMaterail() {
    let matArrayB = [];
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xeddfc2 })); //前  0xafc0ca :灰色
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xffffff })); //后  0x9cb2d1：淡紫
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xafc0ca })); //上  0xd6e4ec： 偏白色
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xeddfc2 })); //下
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xeddfc2 })); //左   0xafc0ca :灰色
    matArrayB.push(new THREE.MeshPhongMaterial({ color: 0xeddfc2 })); //右
    return matArrayB;
}
/////创建窗户
///boxx盒子的x长度
///boxy盒子的y长度
///boxz盒子的z长度
///angle 旋转角度
///x 所在坐标x
///y所在坐标y
///z所在坐标z
///resetRender 回调函数
export function createWindow(boxx, boxy, boxz, angle, x, y, z, name,resetRender) {
    //let that = this; 
    var textloader=new THREE.TextureLoader();
    const texture = textloader.load("../img/icons/chuanghu-1.png", function () {
        resetRender();
    });
    var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
    var material = new THREE.MeshLambertMaterial({
        // color: 0xbbbbbb,
        opacity: 1, //透明度 0-1
        transparent: true, //开启透明度
        map: texture,
    }); //材质对象Material2
    var mesh = new THREE.Mesh(geometry, material);
    mesh.translateX(x);
    mesh.translateZ(z);
    mesh.translateY(y);
    //this.scene.add(mesh);
    return mesh;
}

/////创建卷闸门
///boxx盒子的x长度
///boxy盒子的y长度
///boxz盒子的z长度
///angle 旋转角度
///x 所在坐标x
///y所在坐标y
///z所在坐标z
///resetRender 回调函数
export function createDoor(boxx, boxy, boxz, angle, x, y, z, name,resetRender) {
  //let that = this; 
  var textloader=new THREE.TextureLoader();
  const texture = textloader.load("../img/icons/juanzhamen-1.png", function () {
      resetRender();
  });
  var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
  var material = new THREE.MeshLambertMaterial({
      // color: 0xbbbbbb,
      opacity: 1, //透明度 0-1
      transparent: true, //开启透明度
      map: texture,
  }); //材质对象Material2
  var mesh = new THREE.Mesh(geometry, material);
  mesh.translateX(x);
  mesh.translateZ(z);
  mesh.translateY(y);
  mesh.rotation.y += angle * Math.PI; //-逆时针旋转,+顺时针
  //this.scene.add(mesh);
  return mesh;
}



/////创建电梯
///boxx盒子的x长度
///boxy盒子的y长度
///boxz盒子的z长度
///angle 旋转角度
///x 所在坐标x
///y所在坐标y
///z所在坐标z
///resetRender 回调函数
export function createElevator(boxx, boxy, boxz, angle, x, y, z, name,resetRender) {
  //let that = this; 
  var textloader=new THREE.TextureLoader();
  const texture = textloader.load("../img/icons/dianti.png", function () {
      resetRender();
  });
  var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
  var material = new THREE.MeshLambertMaterial({
      // color: 0xbbbbbb,
      opacity: 1, //透明度 0-1
      transparent: true, //开启透明度
      map: texture,
  }); //材质对象Material2
  var mesh = new THREE.Mesh(geometry, material);
  mesh.translateX(x);
  mesh.translateZ(z);
  mesh.translateY(y);
  mesh.rotation.y += angle * Math.PI; //-逆时针旋转,+顺时针
  //this.scene.add(mesh);
  return mesh;
}



///创建一个烟垛对象
///boxl盒子的长
///boxw盒子的宽
///boxh盒子的高
///xnum盒子x轴上的数量
///znum盒子z轴上的数量
///回调函数
export function createSmokecrib(boxx, boxy, boxz, x,y, z,resetRender,name) {
    //let that = this;
    var textloader=new THREE.TextureLoader();
    const texture = textloader.load("../img/icons/dyanxiang.png", function () {
        resetRender();
    });
    var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
    var material = new THREE.MeshLambertMaterial({
        // color: 0xbbbbbb,
        opacity: 0.8, //透明度 0-1
        transparent: true, //开启透明度
        map: texture,
    }); //材质对象Material2
    var mesh = new THREE.Mesh(geometry, material);
    mesh.translateX(x);
    mesh.translateZ(z);
    mesh.translateY(y);
    mesh.name=name;
    //this.scene.add(mesh);
    return mesh;
}


///创建一个辅料对象
///boxl盒子的长
///boxw盒子的宽
///boxh盒子的高
///xnum盒子x轴上的数量
///znum盒子z轴上的数量
///回调函数
export function createSub(boxx, boxy, boxz, x,y, z,resetRender,name) {
  //let that = this;
  var textloader=new THREE.TextureLoader();
  const texture = textloader.load("../img/icons/fuliaoxiang.png", function () {
      resetRender();
  });
  var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
  var material = new THREE.MeshLambertMaterial({
       //color: 0xbbbbbb,
      opacity: 0.8, //透明度 0-1
      transparent: true, //开启透明度
      map: texture,
  }); //材质对象Material2
  var mesh = new THREE.Mesh(geometry, material);
  mesh.translateX(x);
  mesh.translateZ(z);
  mesh.translateY(y);
  mesh.name=name;
  //this.scene.add(mesh);
  return mesh;
}



 ///添加柱子对象
///scene相机
///boxl盒子的长
///boxw盒子的宽
///boxh盒子的高
///x位置起使坐标
///z位置起使坐标
export function createPillar(boxx, boxy, boxz, x, y,z,name) {
  var geometry = new THREE.BoxGeometry(boxx, boxy, boxz); //创建一个几何对象
  var material = new THREE.MeshLambertMaterial({
    color: 0xffffff,
    opacity: 0.9, //透明度 0-1
    transparent: true, //开启透明度
  }); //材质对象Material2
  var mesh = new THREE.Mesh(geometry, material);
  mesh.translateX(x);
  mesh.translateZ(z);
  mesh.translateY(y);
  mesh.name = name;
  //this.scene.add(mesh);
  return mesh;
}


//墙上挖门，通过两个几何体生成BSP对象
export function createResultBsp(bsp, objects_cube) {
    var material = new THREE.MeshPhongMaterial({
      color:0xeddfc2,
      specular:0x000000,
      shininess: 30,
      transparent: false,
      opacity: 1,
    });
    var BSP = new ThreeBSP(bsp);
    for (var i = 0; i < objects_cube.length; i++) {
      var less_bsp = new ThreeBSP(objects_cube[i]);
      BSP = BSP.subtract(less_bsp);
    }
    var result = BSP.toMesh(material);
    result.material.flatshading = THREE.FlatShading;
    result.geometry.computeFaceNormals(); //重新计算几何体侧面法向量
    result.geometry.computeVertexNormals();
    result.material.needsUpdate = true; //更新纹理
    result.geometry.buffersNeedUpdate = true;
    result.geometry.uvsNeedUpdate = true;
    //this.scene.add(result);
    return result;
  }
  
 
  ///开启辅助坐标
  ///size 辅助坐标长度
  export function getAxesHelper(size){
    return new THREE.AxesHelper(size);
  }
  ///场景
  export function getScene(){
    return  new THREE.Scene();
  }
  //创建点光源
  ///coler 点光源颜色 0x444444
  / ///posx 点光源在x轴上的位置
  ///posy 点光源在y轴上的位置
  ///posz 点光源在z轴上的位置
  export function createPoint(coler,posx,posy,posz){
    var point = new THREE.PointLight(coler);
    point.position.set(posx, posy, posz); //点光源位置
    return  point;
  }
  ///创建环境光
  ///coler 环境光颜色 0xcccccc
  export function createAmbient(coler){
    return new THREE.AmbientLight(coler);
  }
  ///创建地面
  ///path 贴图地址
  ///width 地面宽度
  ///height 地面长度
  ///回调函数
  export function createGround(path,width,height,resetRender){
    var textloader=new THREE.TextureLoader();
    var _this=this;
    const texture = textloader.load(path, function () {
        //that.resetRender();
        resetRender();
      });
      var planeGeometry = new THREE.PlaneGeometry(width, height); //创建一个地面网格
      var planeMaterial = new THREE.MeshLambertMaterial({ map: texture });
      var plane = new THREE.Mesh(planeGeometry, planeMaterial);
      plane.rotation.x = -0.5 * Math.PI; //地面进行旋转90度
      plane.position.set(0, 0, 0);
      plane.receiveShadow = true;
      plane.name='地板';
      return plane;
  }
  ///创建相机对象
  //fov — 摄像机视锥体垂直视野角度
//aspect — 摄像机视锥体长宽比
//near — 摄像机视锥体近端面
//far — 摄像机视锥体远端面
  export function createCamera(fov,aspect,near,far){
    return new THREE.PerspectiveCamera(fov,aspect, near,far); 
  }
  //创建渲染器
  export function createWebGLRenderer(){
    return new THREE.WebGLRenderer({
      antialias: true, //开启锯齿
      alpha: true//透明度，这个属性至关重要
    });
  }
  //光线投射用于进行鼠标拾取（在三维空间中计算出鼠标移过了什么物体）。
  export function createRaycaster(){
    return new THREE.Raycaster();
  }
  ///对 Vector2 实例进行遍历将按相应的顺序生成它的分量 (x, y)。
  export function cteateVector2(){
    return new THREE.Vector2();
  }